import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('appLanguage') || 'CN';
    });

    // Save language preference to localStorage when it changes
    useEffect(() => {
        localStorage.setItem('appLanguage', language);
    }, [language]);

    const translations = {
        EN: {
            // Header translations
            home: "Home",
            package: "Membership",
            course: "Course",
            title: "Online Beauty Business Academy",
            language: "Language",
            selectLanguage: "Select Language",
            // Home page translations
            heroItems: [
                {
                    title: 'Expand Your Knowledge',
                    subtitle: 'Learn from industry experts through our comprehensive premium courses',
                    image: '/images/hero/hero1.jpeg'
                    // cta: 'Browse Courses'
                },
                {
                    title: 'Master New Skills',
                    subtitle: 'Transform your career with our exclusive learning programs',
                    image: '/images/hero/hero2.jpeg'
                    // cta: 'Browse Courses'
                },
                {
                    title: 'Premium Learning Experience',
                    subtitle: 'Receive world-class education from anywhere in the world',
                    image: '/images/hero/hero2.jpeg'
                    // cta: 'Join Now'
                }
            ],
            sectionTitle: "Exclusive courses taught by industry leaders with cutting-edge curriculum",
            bookNow: "Book Now",
            upcomingCourses: "Upcoming Courses",
            membership: {
                exclusiveOffer: "EXCLUSIVE OFFER",
                premiumMembership: "Premium Membership Plans",
                mostPopular: "MOST POPULAR",
                free: "Free",
                gold: "Gold",
                platinum: "Platinum",
                titanium: "Titanium",
                perYear: "/year",
                per3Years: "/3 years",
                startFree: "Start Free",
                subscribeNow: "Subscribe Now",
                comingSoon: "Coming Soon",
                availableFrom: "Available from",
                freeFeatures: [
                    "Unicorn Cloud Course [Introductory]",
                    "Teacher Hai [36 Beauty Business Strategies]"
                ],
                goldFeatures: [
                    "Unlimited access to selected courses for 1 year"
                ],
                platinumFeatures: [
                    "Unlimited access to all courses for 1 year",
                    "New courses included at no extra cost"
                ],
                titaniumFeatures: [
                    "3 years unlimited access",
                    "All new courses included",
                    "Teacher Hai's offline courses",
                    "Darren's group coaching sessions",
                    "Exclusive offline salon events"
                ],
                callNow: 'Call for more details & discount'
            },
            workshopPage: {
                masterTitle: "Master New Beauty Industry Technologies",
                masterSubtitle: "Exclusive Courses for Beauty Entrepreneurs in Asia",
                recordedTitle: "Recorded Masterclasses",
                onlineTitle: "Live Virtual Workshops",
                offlineTitle: "In-Person Ateliers",
                viewAll: "View All",
                watchNow: "Watch Now",
                registerNow: "Register Now",
                virtualBadge: "Virtual",
                inPersonBadge: "In-Person",
                recordedBadge: "Recorded",
                allWorkshops: "All Workshops",
                noCoursesAvailable: "No courses available...",
                startsInDays: "Starts in {days}d {hours}h",
                startsInHours: "Starts in {hours}h {minutes}m",
                startingSoon: "Starting soon!",
                off: "OFF",
                comingSoon: "Coming Soon",
                limited: "Limited",
                reserve: "Reserve"
            },
            membershipInfoPage: {
                membership: "Membership",
                videoPresentation: "Preview",
                noImagesAvailable: "No image found",
                imageNotAvailable: "Failed to load image",
                videoFailedToLoad: "Failed to load video",
                subscribe: "Subscribe",
                back: "back",
            },
            ourCollaborators: "Our Collaborators",
            mainCollaborators: "Main Collaborators",
            partners: "Partners & Supporters",
            trustedBy: "Trusted By Industry Leaders",
            login: "Login",
            businessManagment: "Business Management",
            skillsetCourse: "Skillset",
            // Footer translations
            footer: {
                companyName: "BEAUTYEDU ONLINE Beauty Industry Online Business School",
                companyDescription: "Let the beauty industry president have three no restrictions (no regional restrictions, no time restrictions, no space restrictions), anytime, anywhere, you want to learn",
                quickLinks: "Quick Links",
                resources: "Resources",
                home: "Home",
                courses: "Courses",
                membership: "Membership",
                faq: "FAQ",
                support: "Support",
                careers: "Careers",
                copyright: "All rights reserved",
                privacyPolicy: "Privacy Policy",
                terms: "Terms of Service",
                accessibility: "Accessibility"
            },
            whyChooseUs: {
                title: "Why Choose Us?",
                subtitle: "Our achievements speak for themselves. Here's what sets us apart in the beauty education industry.",
                stats: {
                    certified: "Certified entities by local government",
                    materials: "Copyrighted materials",
                    owners: "Beauty salon owners in our network",
                    data: "Beauty stakeholders data"
                }
            },
        },
        BM: {
            home: "Laman Utama",
            package: "Keahlian",
            course: "Kursus",
            title: "Akademi Perniagaan Kecantikan Atas Talian",
            language: "Bahasa",
            selectLanguage: "Pilih Bahasa",
            heroItems: [
                {
                    title: 'Luaskan Pengetahuan Anda',
                    subtitle: 'Belajar daripada pakar industri melalui kursus premium kami yang komprehensif',
                    image: '/images/hero/hero1.jpeg',
                    // cta: 'Layari Kursus'
                },
                {
                    title: 'Kuasai Kemahiran Baru',
                    subtitle: 'Ubah kerjaya anda dengan program pembelajaran eksklusif kami',
                    image: '/images/hero/hero2.jpeg',
                    // cta: 'Layari Kursus'
                },
                {
                    title: 'Pengalaman Pembelajaran Premium',
                    subtitle: 'Terima pendidikan bertaraf dunia dari mana sahaja di dunia',
                    image: '/images/hero/hero3.jpeg',
                    // cta: 'Sertai Sekarang'
                }
            ],
            sectionTitle: "Kursus eksklusif diajar oleh pemimpin industri dengan kurikulum terkini",
            bookNow: "Tempah Sekarang",
            upcomingCourses: "Kursus Akan Datang",
            membership: {
                exclusiveOffer: "TAWARAN EKSKLUSIF",
                premiumMembership: "Pelan Keahlian Premium",
                mostPopular: "PALING POPULAR",
                free: "Percuma",
                gold: "Emas",
                platinum: "Platinum",
                titanium: "Titanium",
                perYear: "/tahun",
                per3Years: "/3 tahun",
                startFree: "Mulakan Percuma",
                subscribeNow: "Langgan Sekarang",
                comingSoon: "Akan Datang",
                availableFrom: "Akan tersedia pada",
                freeFeatures: [
                    "Kursus Awan Unicorn [Pengenalan]",
                    "Cikgu Hai [36 Strategi Perniagaan Kecantikan]"
                ],
                goldFeatures: [
                    "Akses tanpa had ke kursus terpilih selama 1 tahun"
                ],
                platinumFeatures: [
                    "Akses tanpa had ke semua kursus selama 1 tahun",
                    "Kursus baru termasuk tanpa kos tambahan"
                ],
                titaniumFeatures: [
                    "3 tahun akses tanpa had",
                    "Semua kursus baru termasuk",
                    "Kursus luar talian Cikgu Hai",
                    "Sesi bimbingan berkumpulan Darren",
                    "Aktiviti salon eksklusif luar talian"
                ],
                callNow: 'Hubungi untuk maklumat lanjut & diskaun'
            },
            workshopPage: {
                masterTitle: "Kuasa Pengetahuan Teknologi Baharu dalam Industri Kecantikan",
                masterSubtitle: "Kursus Eksklusif untuk Usahawan Kecantikan di Asia",
                recordedTitle: "Kelas Induk Rakaman",
                onlineTitle: "Bengkel Maya Langsung",
                offlineTitle: "Atelier Bersemuka",
                viewAll: "Lihat Semua",
                watchNow: "Tonton Sekarang",
                registerNow: "Daftar Sekarang",
                virtualBadge: "Maya",
                inPersonBadge: "Bersemuka",
                recordedBadge: "Rakaman",
                allWorkshops: "Semua Bengkel",
                noCoursesAvailable: "Tiada kursus tersedia...",
                startsInDays: "Bermula dalam {days}h {hours}j",
                startsInHours: "Bermula dalam {hours}j {minutes}m",
                startingSoon: "Akan bermula!",
                off: "DISKAUN",
                comingSoon: "Akan Datang",
                limited: "Terhad",
                reserve: "Tempah"
            },
            membershipInfoPage: {
                membership: "Keahlian",
                videoPresentation: "Persembahan Video",
                noImagesAvailable: "Tiada gambar tersedia",
                imageNotAvailable: "Gambar tidak tersedia",
                videoFailedToLoad: "Video gagal dimuatkan",
                subscribe: "Langgan",
                back: "Kembali"
            },
            ourCollaborators: "Kolaborator Kami",
            mainCollaborators: "Kolaborator Utama",
            partners: "Rakan & Penyokong",
            trustedBy: "Dipercayai Rakan Industri Terkemuka",
            login: "Log Masuk",
            businessManagment: "Pengurusan Perniagaan",
            skillsetCourse: "Kemahiran",
            // Footer translations
            footer: {
                companyName: "BEAUTYEDU ONLINE Sekolah Perniagaan Dalam Talian Industri Kecantikan",
                companyDescription: "Biarkan presiden industri kecantikan mempunyai tiga tanpa sekatan (tiada sekatan wilayah, tiada sekatan masa, tiada sekatan ruang), bila-bila masa, di mana sahaja, anda ingin belajar",
                quickLinks: "Pautan Pantas",
                resources: "Sumber",
                home: "Laman Utama",
                courses: "Kursus",
                membership: "Keahlian",
                faq: "Soalan Lazim",
                support: "Sokongan",
                careers: "Kerjaya",
                copyright: "Hak cipta terpelihara",
                privacyPolicy: "Dasar Privasi",
                terms: "Terma Perkhidmatan",
                accessibility: "Kebolehcapaian"
            },
            whyChooseUs: {
                title: "Kenapa Pilih Kami?",
                subtitle: "Pencapaian kami bercakap untuk diri sendiri. Inilah yang membezakan kami dalam industri pendidikan kecantikan.",
                stats: {
                    certified: "Entiti bertauliah oleh kerajaan tempatan",
                    materials: "Bahan berhak cipta",
                    owners: "Pemilik salon kecantikan dalam rangkaian kami",
                    data: "Data pemegang kepentingan kecantikan"
                }
            },
        },
        CN: {
            home: "主页",
            package: "会员",
            course: "课程",
            title: "线上美业商学院",
            language: "语言",
            selectLanguage: "选择语言",
            heroItems: [
                {
                    title: '扩展您的知识',
                    subtitle: '通过我们综合性的优质课程向行业专家学习',
                    image: '/images/hero/hero1.jpeg',
                    // cta: '浏览课程'
                },
                {
                    title: '精通新技能',
                    subtitle: '通过我们的独家学习计划改变您的职业生涯',
                    image: '/images/hero/hero2.jpeg',
                    // cta: '浏览课程'
                },
                {
                    title: '优质的学习体验',
                    subtitle: '在世界任何地方接受世界一流的教育',
                    image: '/images/hero/hero3.jpeg',
                    // cta: '立即加入'
                }
            ],
            sectionTitle: "由行业领袖以前沿课程授课的专属课程",
            bookNow: "立即预订",
            upcomingCourses: "即将开始的课程",
            membership: {
                exclusiveOffer: "独家尊贵优惠",
                premiumMembership: "豪华会员计划",
                mostPopular: "最受欢迎",
                free: "免费",
                gold: "黄金",
                platinum: "白金",
                titanium: "钛合金",
                perYear: "/1年",
                per3Years: "/3年",
                startFree: "从免费开始",
                subscribeNow: "立即订阅",
                comingSoon: "即将推出",
                availableFrom: "发布日期",
                freeFeatures: [
                    "橙美云课【课程导读】",
                    "海老师【美业门店盈利36计】"
                ],
                goldFeatures: [
                    "一年无限学习 (指定课程）"
                ],
                platinumFeatures: [
                    "一年无限学习 (所有课程）",
                    "新课上线无需支付 (只限在一年期限的更新）"
                ],
                titaniumFeatures: [
                    "三年无限学习",
                    "新课上线无需支付",
                    "海老师线下课",
                    "Darren老师群体咨询辅导班",
                    "线上黑金会员身份参与线下沙龙会聚会"
                ],
                callNow: '来电咨询详情及优惠'
            },
            workshopPage: {
                masterTitle: "掌握美业新技术知识",
                masterSubtitle: "来自亚洲最合适美业创业者独家课程",
                recordedTitle: "录播大师课",
                onlineTitle: "线上直播工作坊",
                offlineTitle: "线下精品课程",
                viewAll: "查看全部",
                watchNow: "立即观看",
                registerNow: "立即报名",
                virtualBadge: "线上",
                inPersonBadge: "线下",
                recordedBadge: "录播",
                allWorkshops: "所有课程",
                noCoursesAvailable: "没有可用的课程...",
                startsInDays: "{days}天{hours}小时后开始",
                startsInHours: "{hours}小时{minutes}分钟后开始",
                startingSoon: "即将开始!",
                off: "折",
                comingSoon: "即将推出",
                limited: "限量",
                reserve: "预订"
            },
            membershipInfoPage: {
                membership: "会员",
                videoPresentation: "视频介绍",
                noImagesAvailable: "没有可用的图片",
                imageNotAvailable: "图片不可用",
                videoFailedToLoad: "视频加载失败",
                subscribe: "订阅",
                back: "返回"
            },
            ourCollaborators: "我们的合作伙伴",
            mainCollaborators: "主要合作伙伴",
            partners: "合作伙伴与支持者",
            trustedBy: "行业领导者信赖",
            login: "登入",
            businessManagment: "经商管理",
            skillsetCourse: "技术升级",
            // Footer translations
            footer: {
                companyName: "BEAUTYEDU ONLINE美业线上商学院",
                companyDescription: "让美业总裁以三无限制（无区域限制，无时间限制，无空间限制），随时随地，想学就学",
                quickLinks: "快速链接",
                resources: "资源",
                home: "主页",
                courses: "课程",
                membership: "会员",
                faq: "常见问题解答",
                support: "支援",
                careers: "就业中心",
                copyright: "版权所有",
                privacyPolicy: "隐私政策",
                terms: "服务条款",
                accessibility: "无障碍访问"
            },
            whyChooseUs: {
                title: "为什么选择我们？",
                subtitle: "我们的成就说明一切。以下是我们在美业教育行业中脱颖而出的原因。",
                stats: {
                    certified: "经当地政府认证的实体",
                    materials: "版权材料",
                    owners: "我们网络中的美业院老板",
                    data: "美业行业相关数据"
                }
            }
        }
    };

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        let fallbackValue = translations['CN'];

        for (const k of keys) {
            value = value?.[k];
            fallbackValue = fallbackValue?.[k];

            if (value === undefined && fallbackValue === undefined) {
                console.warn(`Missing translation for key: ${key}`);
                return key.split('.').pop();
            }
        }

        return value ?? fallbackValue ?? key.split('.').pop();
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};